const colors = require("tailwindcss/colors")

/** Neutral colors switch with the theme: values live in src/index.css (:root and .theme-dark) */
const themed = (name) => `rgb(var(--c-${name}) / <alpha-value>)`

module.exports = {
  content: [
    "./index.html",
    "./public/**/*.html",
    "./src/**/*.{vue,js,ts,jsx,tsx}",
  ],
  important: true,
  theme: {
    extend: {
      fontSize: {
        xs: ["0.813rem", "1rem"],
      },
    },
    colors: {
      transparent: "transparent",
      current: "currentColor",
      "pale-green": themed("pale-green"),
      "light-green": "#29BC68",
      "ligher-green": themed("ligher-green"),
      green: "#00994C",
      "dark-green": "#1C7D45",
      "darkest-green": "#007F36",
      "light-blue": "#53A2FF",
      blue: "#006BE8",
      orange: "#E5A800",
      yellow: "#FFE8B8",
      "dark-yellow": "#997700",
      white: themed("white"), // surfaces (cards, header, grid)
      "on-primary": "#FFFFFF", // text on colored backgrounds, same in both themes
      "off-white": themed("off-white"),
      black: themed("black"),
      gray: themed("gray"),
      "dark-gray": themed("dark-gray"),
      "very-dark-gray": themed("very-dark-gray"),
      "light-gray": themed("light-gray"),
      "light-gray-stroke": themed("light-gray-stroke"),
      "avail-green": colors.emerald, // The green used for marking availability
      red: "#DB1616",
    },
    screens: {
      sm: "640px",
      md: "768px",
      mdlg: "896px",
      lg: "1024px",
      xl: "1280px",
      "2xl": "1536px",
    },
  },
  plugins: [],
  prefix: "tw-",
  safelist: [],
}
